import React, { useState, useEffect, useMemo } from 'react';

import moment from 'moment'
import { Typography } from '@mui/material';
import { VictoryArea, VictoryAxis, VictoryBar, VictoryChart, VictoryGroup, VictoryLegend, VictoryLine, VictoryTheme, VictoryTooltip } from 'victory';

import { FlyOut } from './LineSeries/FlyOut';

export function TimeSeries({
    start,
    end,
    data,
    colors=[
        '#ff0000',
        '#ff8800',
        '#ffff00',
        '#88ff00',
        '#00ff00',
        '#00ffaa',
        '#00ffff',
        '#0088ff',
        '#0000ff'
    ],
    dataKey
}) {
    var primary = "#000000";

    const maxValue = useMemo(() => {
        let max = 0
        if (data instanceof Array) {
            for (let serie of data) {
                for (let value of serie.stats) {
                    max = Math.max(max, parseFloat(value[dataKey] ?? 0) ?? 0)
                }
            }
        } else { 
            for (let value of data.stats) {
                max = Math.max(max, parseFloat(value[dataKey] ?? 0) ?? 0)
            }
        }
        return max
    }, [data])

    const yTickValues = useMemo(() => {
        const ret = Array(5).fill().map((n, i) => (maxValue / 4) * i)
        return ret
    }, [maxValue])

    console.log("yTickValues", yTickValues)
    const [zoomDomain, setZoomDomain] = useState({ x: [moment(start).toDate(), moment(end).toDate()], y: [0, maxValue] })

    useEffect(() => {
        setZoomDomain({ x: [moment(start).format(), moment(end).toDate()], y: [0, maxValue] })
    }, [start])

    useEffect(() => {
        setZoomDomain({ x: [moment(start).toDate(), moment(end).toDate()], y: [0, maxValue] })
    }, [end])
    if (!data) {
        return <Typography>No stats</Typography>
    }

    return (
        <>
            <VictoryChart
                responsive={true}
                zoomDomain={zoomDomain}
                scale={{ x: "time" }}
                height={250}
            >
                <VictoryAxis
                    fixLabelOverlap={true}
                    style={{
                        axisLabel: {
                            fontSize: 10
                        },
                        tickLabels: {
                            fontSize: 6,
                            fontWeight: 'bold',
                            fontFamily: "DM Sans",
                            fill: 'black'
                        }
                    }}
                />
                <VictoryAxis
                    tickValues={yTickValues}
                    tickFormat={(value) => value?.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                    fixLabelOverlap={true}
                    dependentAxis
                    style={{
                        grid: { stroke: 'rgba(127, 127, 127, .3)', strokeWidth: 0.5 },
                        axisLabel: {
                            fontSize: 5,
                            fontWeight: 'bold'
                        },
                        tickLabels: {
                            fontSize: 6,
                            fontWeight: 'bold',
                            fontFamily: "DM Sans",
                            fill: 'black'
                        }
                    }}
                />
                {data instanceof Array ? (      
                    <VictoryGroup>
                        {data.map(
                            (serie, i) => (
                                <VictoryLine
                                    key={serie.name}
                                    data={serie.stats.map((d, i) => ({ x: d.date, y: d[dataKey] }))}
                                    interpolation="linear"
                                    style={{
                                        data: {
                                            stroke: `color-mix(in srgb, ${colors[Math.floor(i % colors.length)]}, black 50%)`,
                                            fill: 'transparent',
                                            strokeWidth: 1
                                        }
                                    }}
                                />
                            )
                        )}
                    </VictoryGroup>
                ) : data instanceof Object ? (
                    <VictoryArea
                        interpolation="linear"
                        data={data.stats}
                        x={(value) => value.date}
                        y={(value) => value[dataKey]}
                        style={{
                            data: { stroke: primary, fill: `color-mix(in srgb, #000, transparent 95%)`, strokeWidth: 1 }
                        }}

                    />
                ) : null}

                <VictoryBar
                    labels={(o) => o[dataKey] ?? 0}
                    labelComponent={
                        <VictoryTooltip
                            renderInPortal={true}
                            flyoutComponent={<FlyOut />}
                            flyoutStyle={{
                                fill: primary,
                            }}
                            style={{
                                fontWeight: 'bold',
                                fill: 'white',
                            }}
                        />
                    }
                    style={{
                        tickLabels: {
                            fontWeight: 'bold',
                        },
                        data: { transform: 'translateX(30pt)', stroke: 'transparent', fill: "transparent" }
                    }}
                    barWidth={110}
                    barRatio={0}

                    interpolation="linear"
                    data={data.stats}
                    x={(value) => value.date}
                    y={(value) => value[dataKey]}
                >
                    <VictoryTooltip
                        center={{ x: 225, y: 30 }}
                        pointerOrientation="bottom"
                        flyoutWidth={150}
                        flyoutHeight={50}
                        pointerWidth={150}
                        cornerRadius={0}
                    />
                </VictoryBar>
            </VictoryChart>
        </>
    )
}